exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/myLoans/cadastralReferenceMobile/modalQuestionCadastral/modalQuestionCadastral.scss
// module id = 2024
// module chunks = 0